import { Component, OnInit } from '@angular/core';
import { MatFormField, MatHint, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { FormControl, Validators, FormsModule, ReactiveFormsModule, FormBuilder, FormGroup } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { AuthService } from '../services/auth/auth.service';
import { AuthLoginModel } from '../models/auth/AuthLoginModel';
import { SystemUserModel } from '../models/api/SystemUserModel';
import { AuthLoginResult } from '../models/auth/AuthLoginResult';
import { Router } from '@angular/router';
import { TherapistService } from '../services/api/TherapistService';
import { TherapistStatusHistoryService } from '../services/api/TherapistStatusHistoryService';
import { map, Observable } from 'rxjs';
import { TherapistStatusHistoryModel } from '../models/api/TherapistStatusHistoryModel';
import { TherapistModel } from '../models/api/TherapistModel';
import { MatMenuModule } from '@angular/material/menu';


@Component({
  selector: 'app-log-in',
  standalone: true,
  imports: [MatFormField, MatLabel, MatIcon, MatHint, MatFormFieldModule, FormsModule, ReactiveFormsModule, MatInputModule, MatButtonModule, MatMenuModule],
  templateUrl: './log-in.component.html',
  styleUrl: './log-in.component.scss'
})
export class LogInComponent implements OnInit {

  loginForm!: FormGroup;
  systemUserDetail: SystemUserModel | undefined;
  authLoginResultDetail: AuthLoginResult | undefined;
  systemUserId: number | undefined;
  therapistStatusDetail: TherapistStatusHistoryModel = new TherapistStatusHistoryModel;
  therapistDetail: TherapistModel = new TherapistModel;
  loggingIn: boolean = false;
  loginFormError: boolean = false;

  constructor(private fb: FormBuilder, private authService: AuthService, private router: Router, private therapistService: TherapistService, private therapistStatusHistoryService: TherapistStatusHistoryService) {
  }

  ngOnInit(): void {
    this.loginForm = this.fb.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required]],

    })
  }

  loginUser() {
    this.loginFormError = false;
    const login: AuthLoginModel = this.loginForm.value;
    this.loggingIn = true;
    
    if (this.loginForm.valid){
    this.authService.login(login).subscribe(data => {
      this.authLoginResultDetail = data;
      if (this.authLoginResultDetail.success === true) {
        this.systemUserDetail = this.authLoginResultDetail.user;
        if (this.systemUserDetail?.userTypeID === 1 || this.systemUserDetail?.userTypeID === 2) {
          this.loggingIn = false;
          this.router.navigate(['/admin/events']);

        } else if (this.systemUserDetail?.userTypeID === 3) {
          this.loggingIn = false;
          this.router.navigate(['/therapist-portal/dashboard']);
        }
      } else {
        this.loginFormError = true;
      }
    })
    }  
  }

getTherapistFromSystemId(systemUserID: number): Observable<TherapistModel | undefined>{
  return this.therapistService.getAllTherapists().pipe(
    map( data => {
      const therapist = data.find(d => d.systemUserID === systemUserID);
      if (therapist){
        return therapist;
      }
      else {
        console.warn("Therapist not found");
        return undefined;
      }
    })
  )

}

  goToLogin() {
    this.router.navigate(['login']);
  }
    goToBook() {
    this.router.navigate(['/']);
  }

}
